// Syncs the option <select> elements on a product page to the matching variant:
// updates the hidden variant-id input, the displayed price, and the add-to-cart
// button's availability state. No framework — this theme has no build step.
(function () {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var variantsJsonEl = document.getElementById('ProductVariantsJson');
  if (!variantsJsonEl) return;
  var variants = JSON.parse(variantsJsonEl.textContent);

  var selects = form.querySelectorAll('.product-page__select');
  var variantIdInput = document.getElementById('ProductVariantId');
  var priceEl = document.getElementById('ProductPrice');
  var submitBtn = document.getElementById('ProductSubmit');

  function selectedOptions() {
    var values = [];
    selects.forEach(function (select) {
      values[Number(select.dataset.optionIndex)] = select.value;
    });
    return values;
  }

  function findMatchingVariant() {
    var current = selectedOptions();
    return variants.find(function (variant) {
      return variant.options.every(function (value, i) {
        return current[i] === undefined || current[i] === value;
      });
    });
  }

  function updateForVariant(variant) {
    if (!variant) return;
    variantIdInput.value = variant.id;
    if (priceEl) priceEl.innerHTML = variant.priceHtml;
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
  }

  selects.forEach(function (select) {
    select.addEventListener('change', function () {
      updateForVariant(findMatchingVariant());
    });
  });

  // thumbnail gallery
  var mainImage = document.getElementById('ProductMainImage');
  document.querySelectorAll('.product-page__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mainImage && btn.dataset.fullSrc) mainImage.src = btn.dataset.fullSrc;
    });
  });
})();
